export const shouldUpdateConversationListFromMessage = (message: {
  type: string;
}): boolean => message.type !== "info";
